import DashboardIcon from '@mui/icons-material/Dashboard'
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'

export const routeBackOfficeSoundAdminCommon = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    icon: DashboardIcon,
    href: '/backoffice/group/dashboard-admin',
    menuHeader: true,
    home: true,
    position: 10,
  },
  {
    route: 'AdminProgramme',
    text: 'Programme audio',
    icon: VolumeUpIcon,
    href: '/backoffice/sound/program',
    menuHeader: true,
    position: 40,
  },
  {
    route: 'AdminAudiotheque',
    text: 'Audiothèque',
    icon: LibraryMusicIcon,
    href: '/backoffice/sound/audiotheque',
    menuHeader: true,
    position: 70,
  },
  {
    route: 'EditProgram',
    text: 'Editer un programme',
    href: '/backoffice/sound/program/edit-program/[programId]',
    menuHeader: false,
  },
  {
    route: 'AddProgramme',
    text: 'Ajouter un programme',
    href: '/backoffice/sound/program/add-programme',
    menuHeader: false,
  },
  {
    route: 'EditAudio',
    text: 'Editer une piste audio',
    href: '/backoffice/sound/audiotheque/edit-audio/[spotId]',
    menuHeader: false,
  },
  {
    route: 'AddAudio',
    text: 'Créer une piste audio',
    href: '/backoffice/sound/audiotheque/add-audio',
    menuHeader: false,
  },
]
